<template>
  <b-form-group
    label="Teslim Yeri"
    label-for="delivery_location"
  >
    <validation-provider
      #default="{ errors }"
      name="Teslim Yeri"
      rules="required"
    >
      <b-form-input
        id="delivery_location"
        v-model="dataItem.delivery_location"
        placeholder="Teslim Yeri"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'DeliveryLocation',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
